import cookie from '../client/utils/cookie';

export function initializeYleSelva() {
  const existingYleSelvaId = cookie.getItem('yle_selva');
  const yleSelvaId = existingYleSelvaId || createYleSelvaId();

  if (!existingYleSelvaId) {
    saveYleSelvaToCookie(yleSelvaId);
  }

  return yleSelvaId;
}

function saveYleSelvaToCookie(yleSelvaId: string) {
  const expires = new Date();
  expires.setMonth(expires.getMonth() + 52); // expire selva cookie 52 months from now

  const cookieValue = cookie.setItem(
    'yle_selva',
    yleSelvaId,
    expires,
    '/',
    'yle.fi',
    true
  );
  if (cookieValue != yleSelvaId) {
    cookie.setItem('yle_selva', yleSelvaId, expires, '/', '.yle.fi', true);
  }
}

function createYleSelvaId() {
  return Date.now() + '' + Math.floor(Math.random() * 10000000);
}
